import AllRoutes from "./AllRoutes";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";

function App() {
  // Suppress ResizeObserver error in development
  if (typeof window !== "undefined") {
    const resizeObserverLoopErr = () => {
      const resizeObserverErr = window.ResizeObserver;
      if (resizeObserverErr) {
        resizeObserverErr.prototype.observe = () => {};  // Overwrite to do nothing
      }
    };
    resizeObserverLoopErr();
  }

  return (
    <>
      <Provider store={store}>
        <div className="App">
          <AllRoutes />
        </div>
      </Provider>
    </>
  );
}

export default App;
